require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default() {
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, _react["default"].createElement("path", {
    d: "M35.375 29.816a2.135 2.135 0 0 0-2.184.012l-3.406 2.031a2.14 2.14 0 0 1-2.418-.144c-1.21-.945-3.16-2.535-4.855-4.23-1.696-1.696-3.285-3.645-4.227-4.856a2.134 2.134 0 0 1-.148-2.414l2.035-3.41a2.167 2.167 0 0 0 .008-2.192l-5.004-8.547a2.161 2.161 0 0 0-2.38-1.003c-.905.222-2.081.757-3.312 1.992-3.859 3.855-5.906 10.36 8.598 24.863 14.504 14.504 21.008 12.457 24.863 8.598 1.239-1.235 1.77-2.41 1.992-3.317a2.148 2.148 0 0 0-1-2.37 9730.848 9730.848 0 0 1-8.562-5.013zm0 0"
  }));
};

exports["default"] = _default;